import kotlinx.browser.window

actual fun triggerNudgeHaptic() {
    val nav = window.navigator.asDynamic()
    // Vibration API (supported on Android Chrome; a no-op/undefined elsewhere, e.g. desktop/iOS Safari).
    if (nav.vibrate != null) {
        nav.vibrate(arrayOf(120, 90, 120))
    }
}
